import Section from "../Section";
import Swiper from 'swiper';

export default class InfoColumns extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    const nextEl = this.element.querySelector('.swiper-button--next');
    const prevEl = this.element.querySelector('.swiper-button--prev');
    const swiperContainer = this.element.querySelector('.swiper-container');
    const slidesPerView = parseInt(this.element.dataset.slidesPerRow);
    this.swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      allowTouchMove: true,
      navigation: {
        nextEl,
        prevEl,
      },
      breakpoints: {
        // when window width is >= 768px
        769: {
          slidesPerView: slidesPerView,
        },
      },
      watchOverflow: true,
      autoHeight: true,
      pagination: {
        el: swiperContainer.querySelectorAll('.swiper-pagination'),
        clickable: true,
      },
    });
  }
}
